import { AvailableMatch } from '@/components/lobby-details/lobby-game-modes/head-to-head/available-matches/available-matches-list.component';
import { MatchSelectionStatus } from '@/components/lobby-details/lobby-game-modes/head-to-head/available-matches/match-selection-card.component';
import { formatTimeToAmPm } from '@/utils';

export const mapMatchesToCards = (
	matchesData: any[] | undefined,
	userMatchesData: any[] | undefined
): AvailableMatch[] => {
	if (!matchesData) return [];

	return matchesData.map((match) => {
		const userMatch = userMatchesData?.find((um: any) => um.matchid === match.id);
		const isOngoing = !!userMatch?.opponentid && !userMatch?.winnerid;
		const h2hStatus = (userMatch?.h2hstatus || '').toUpperCase();
		const isCompleted = !!userMatch?.winnerid || h2hStatus === 'COMPLETED';
		const isLiveStatus = h2hStatus === 'LIVE' || h2hStatus === 'ACTIVE';

		let status: MatchSelectionStatus = (
			new Date() > new Date(match.opening_time) ? 'LIVE' : 'SOON'
		) as MatchSelectionStatus;

		if (isCompleted) {
			status = 'COMPLETED';
		} else if (isLiveStatus) {
			status = 'LIVE';
		}

		return {
			id: match.id,
			title: match.name,
			secondaryInfo: formatTimeToAmPm(match.opening_time),
			status,
			buttonText: match.isMatchSelectedByUser
				? isOngoing
					? 'Back to Match'
					: 'Resume trading'
				: 'Start Predicting',
			isUserSelectMatch: !!match.isMatchSelectedByUser,
			isClosedForUser: !!match.isClosedForUser,
			isOngoing,
			h2hMatchId: userMatch?.h2hmatchid,
			points: userMatch?.eloDiff ? Number(userMatch.eloDiff) : undefined,
			resultText: userMatch?.matchResult || undefined,
			pnl: userMatch?.userPnl ? Number(userMatch.userPnl) : undefined,
			pnlIndicator: userMatch?.pnlIndicator || undefined,
			pnlDiff: userMatch?.pnlDiff,
			isWinner: !!match.isWinner,
			usersInMatch: match.usersInMatch,
			opponent: userMatch?.opponentid
				? {
						id: userMatch.opponentid,
						name: userMatch.opponentfullname || 'Opponent',
					}
				: undefined,
		};
	});
};
export const sortMatchesByStatus = (matches: AvailableMatch[]): AvailableMatch[] => {
	return [...matches].sort((a, b) => {
		const getPriority = (match: AvailableMatch) => {
			if (match.isClosedForUser) return 5;
			if (match.status === 'LIVE' && match.isOngoing) return 1;
			if (match.status === 'SOON' && match.isOngoing) return 2;
			if (match.status === 'LIVE') return 3;
			if (match.status === 'SOON') return 4;
			return 6;
		};

		const priorityA = getPriority(a);
		const priorityB = getPriority(b);

		if (priorityA !== priorityB) {
			return priorityA - priorityB;
		}

		return a.title.localeCompare(b.title);
	});
};
